export const refIdRx = RegExp(/^[a-zA-Z0-9_.]+$/);
export const usernameRx = RegExp(/^[a-zA-Z0-9@!#+\-_.]+$/);
export const nameSurnameRx = RegExp(/^\p{L}+([- ]\p{L}+)*$/u);
export const emailRx = RegExp(/(.+)@(.+){2,}\.(.+){2,}/);
export const digitsRx = RegExp(/^[0-9]+$/);

export const TWO_FACTOR_REQUIRED = 'err.two-factor-password.required';
